(function($){
    $(document).ready(function(){
        $('.blog-load-more-js').on('click',function(){
            var self = $(this);
            var page = $(this).data('paged');
            var mainList = $('.blog-main-list-js');
            $.post(app_start_local_data.ajaxurl,{
                action: 'load_more_blog_posts',
                appstar_data: {
                    paged: page
                }
            },function(data){
                var get_data = JSON.parse(data);
                if(get_data.page_remain === 0){
                    self.fadeOut();
                }else{
                    self.data('paged',parseInt(page)+1);
                }
                if(get_data.posts){
                    get_data.posts.forEach(function(item){
                        mainList.append(blogMarkUp(item));
                        $('.blog-main-list-js .blog-post').last().fadeIn(700);
                    });
                }
            });
        });
    });

    function blogMarkUp(post){
        var markup = '<a href="'+post.link+'" style="display: none" class="blog-post">' +
            '<div class="wrapper">' +
            '<div class="thumb">' +
            post.image+
            '</div>' +
            '<h3 class="title">'+post.title+'</h3>' +
            '<div class="detail box-orient">' +
            post.description+
            '</div>' +
            '</div>' +
            '</a>';
        return markup;
    }
})(jQuery)